export const getSlugString = string =>
    string.toLowerCase().split(' ').join('-').split(',').join('')
